import React from 'react';
import { useTheme } from '@veneer/theme';
import { StyledDivider } from './styled';

export type DividerProps = {
  className?: string;
  style?: React.CSSProperties;
  'data-testid'?: string;
};

export function Divider(props: Readonly<DividerProps>): React.ReactElement {
  const theme = useTheme();
  const { className, style, 'data-testid': dataTestId } = props;

  return (
    <StyledDivider
      $veneerTheme={theme}
      className={className}
      style={style}
      data-testid={dataTestId || 'react-device-management-mfe-divider'}
    />
  );
}
